import {gql} from "@irati/utils/gql"

import RewardOrder from "../query/fragments/RewardOrder"

const query = gql`
  mutation CreateReward($payload: CreateRewardArgs!) {
    createReward(payload: $payload) {
      rewardOrder {
        ...RewardOrder
      }
      paymentOrder {
        uuid
        currency
        amount
      }
    }
  }
  ${RewardOrder}
`

export const toString = query.loc.source.body

export default query
